@if (facilities$ | async; as facilities) { @if (facilities.length > 0) {
<div class="facilities-wrapper">
  <div class="facilities-header">
    <div>
      <span>facilities</span>
      <span>&nbsp;({{ facilities.length }})</span>
    </div>
    <button class="iconf-btn-blank" (click)="addFacility()">
      <mat-icon>add_circle</mat-icon>
      add facility
    </button>
  </div>
  <app-separator></app-separator>
  <app-facility-list title="offshore" [facilities]="facilities"> </app-facility-list>
</div>
<app-separator></app-separator>
<div class="facility-systems-list-wrapper">
  <router-outlet></router-outlet>
</div>
} @if (facilities.length == 0) {
<div class="facilities-placeholder">
  <app-placeholder
    [icon]="noFacilitiesIcon"
    title="No facilities added"
    description="Start selecting the facilities from onshore or offshore for you next systems configuration."
    buttonCaption="add facility"
    (buttonClick)="addFacility()"
  >
  </app-placeholder>
</div>
} }
